import { render } from "./CommentInput.vue?vue&type=template&id=60d82547&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"

import "./CommentInput.vue?vue&type=style&index=0&id=60d82547&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d82547"],['__file',"src/scripts/view/review/components/CommentInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d82547"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d82547', __exports__)) {
    api.reload('60d82547', __exports__)
  }
  
  module.hot.accept("./CommentInput.vue?vue&type=template&id=60d82547&scoped=true", () => {
    api.rerender('60d82547', render)
  })

}


export default __exports__